{
  "Int": {
    "type": "number",
    "multipleOf": 1.0
  },
  "NullableInt": {
    "type": ["number", "null"],
    "multipleOf": 1.0
  },
  "JavaInt": {
    "type": "number",
    "default": 0,
    "multipleOf": 1.0,
    "minimum": -2147483648,
    "maximum": 2147483647
  },
  "JavaBool": {
    "type": "boolean",
    "default": false
  },
  "NullableBool": {
    "type": ["boolean", "null"]
  },
  "reference": {
    "type": ["string"],
    "pseudoType": ["ref"],
    "_wixReference": true
  },
  "nullableReference": {
    "type": ["null", "string"],
    "pseudoType": ["ref"],
    "_wixReference": true
  },
  "weakReference": {
    "type": ["string"],
    "pseudoType": ["weakRef"],
    "_wixReference": true
  },
  "nullableWeakReference": {
    "type": ["null", "string"],
    "pseudoType": ["weakRef"],
    "_wixReference": true
  },
  "referenceList": {
    "type": ["array"],
    "items": [
      {
        "type": ["null", "string"],
        "pseudoType": ["ref"]
      }
    ],
    "pseudoType": ["refList"],
    "_wixReference": true
  },
  "nullableReferenceList": {
    "type": ["array", "null"],
    "items": [
      {
        "type": ["null", "string"],
        "pseudoType": ["ref"]
      }
    ],
    "pseudoType": ["refList"],
    "_wixReference": true
  },
  "DataNode": {
    "type": "object",
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        }
      }
    }
  },
  "PropDataNode": {
    "type": "object",
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "schemaVersion": {
            "type": ["string", "null"],
            "default": "1.0"
          },
          "autoGenerated": {
            "type": ["boolean", "null"]
          },
          "pageId": {
            "type": "string"
          },
          "sig": {
            "type": "string"
          }
        }
      }
    }
  }
}
